import { render, staticRenderFns } from "./ExamineeAntiCheatModule.vue?vue&type=template&id=58de3ff0&scoped=true&"
import script from "./ExamineeAntiCheatModule.vue?vue&type=script&lang=js&"
export * from "./ExamineeAntiCheatModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de3ff0",
  null
  
)

export default component.exports